module.exports = __webpack_public_path__ + "img/download.e432ad34.png";